<textarea 
[class]="class" 
[rows]="rows" 
[id]="id"
[name]="id"
[title]="title" 
[placeholder]="placeholder" 
[ngClass]="{'is-invalid':control.touched && control.invalid}" 
[formControl]="control"
></textarea>

 